class CartValidation {
  /**
   * @param {InfoField} infoField
   */
  constructor(infoField) {
    this.active = true;
    this.lastFetchId = 0;
    this.observer = null;
    this.infoField = infoField;
  }

  setup() {
    if (!this.active) {
      this.active = localStorage.getItem("pk-cart-validation") === "true";
    }
    console.log("debug-cv", "setup", "active", this.active);
    if (!this.active) {
      return;
    }

    this.disableCheckoutButtons();
    this.validateQuantity();
    this.setupListeners();

    this.infoField.setup()
  }

  setupListeners() {
    const onChange = (timeout) => {
      console.log("debug-cv", "onChange");
      this.disableCheckoutButtons();
      this.abortLastFetch();

      setTimeout(() => {
        this.abortLastFetch();
        this.validateQuantity();
      }, timeout != null ? timeout : 1000);
    };

    if (window.publish !== undefined && window.subscribe !== undefined && PUB_SUB_EVENTS?.cartUpdate !== undefined) {
      console.log("debug-cv", "setup", "publish found");
      window.subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        console.log("debug-cv", "cartUpdate");
        onChange(0);
      });
    } else {
      console.log("debug-cv", "setup", "publish NOT found");
      this.setupMutationObserver(onChange);
      this.setupChangeListener(onChange);
      this.setupClickListener(onChange);
    }
  }

  setupMutationObserver(onChange) {
    const targetNode = document.querySelector('.cart-count-bubble, #cart-icon-bubble, .header__cart-count');
    if (targetNode) {
      this.observer = new MutationObserver(() => {
        console.log("debug-cv", "MutationObserver");
        onChange();
      });
      this.observer.observe(targetNode, { childList: true, subtree: true, characterData: true });
    }
  }

  setupChangeListener(onChange) {
    document.addEventListener('change', (event) => {
      if (event.target.matches('input[name="updates[]"], .cart-quantity-input, .quantity__input, .cart-qty')) {
        console.log("debug-cv", "change");
        onChange();
      }
    });
  }

  setupClickListener(onChange) {
    document.addEventListener('click', (event) => {
      if (
        event.target.closest('button[name="plus"], button[name="minus"], .quantity__button, #cart-icon, .x-cart-item-quantity button, .cart-item__quantity button')
        || event.target.matches("#cart-icon")
      ) {
        console.log("debug-cv", "click");
        onChange();
      }
    });
  }

  abortLastFetch() {
    this.lastFetchId += 1;
    console.log("debug-cv", "abortLastFetch", "new lastFetchId", this.lastFetchId);
  }

  validateQuantity() {
    this.fetchQuantity()
      .then((isValid) => {
        if (isValid == null) {
          return
        }

        if (isValid) {
          this.enableCheckoutButtons();
          this.infoField.hide()
        } else {
          this.disableCheckoutButtons();
          this.infoField.show()
        }
      })
  }

  /**
   * @return {Promise<boolean | null>}
   */
  fetchQuantity() {
    const fetchId = this.lastFetchId;
    console.log("debug-cv", "validateMultiples", "fetchId", fetchId);

    return fetch(`${window.Shopify.routes.root}cart.js`)
      .then(res => res.json())
      .then(cart => {
        console.log("debug-cv", "validateMultiples", "then", "fetchId", fetchId, this.lastFetchId);
        if (fetchId !== this.lastFetchId) {
          return null;
        }

        const total = cart.item_count;
        const isValid = this.quantityIsValid(total);
        console.log("debug-cv", "total", total, "isValid", isValid, "fetchId", fetchId);

        return isValid
      });
  }

  getCheckoutButtons() {
    return document.querySelectorAll('button[name="checkout"], [action="/checkout"] button, .checkout-button-logic, #dynamic-checkout-cart');
    // return document.querySelectorAll('button[name="checkout"], [action="/checkout"] button, .checkout-button-logic, shop-pay-wallet-button, shopify-google-pay-button');
  }

  disableCheckoutButtons() {
    this.getCheckoutButtons().forEach(btn => {
      btn.setAttribute('disabled', 'disabled');
      btn.style.opacity = "0.25";
      btn.style.cursor = "not-allowed";
      btn.style.pointerEvents = "none";
    });
  }

  enableCheckoutButtons() {
    console.log("debug-cv", "enableCheckoutButtons");
    this.getCheckoutButtons().forEach(btn => {
      btn.removeAttribute('disabled');
      btn.style.opacity = "1";
      btn.style.cursor = "pointer";
      btn.style.pointerEvents = "auto";
    });
  }

  quantityIsValid(quantity) {
    if (quantity <= 1 || quantity === 3 || quantity === 6) {
      return true;
    }

    if (quantity > 6 && quantity % 6 === 0) {
      return true;
    }

    return false;
  }
}

class InfoField {

  id = "pk-info-field";

  constructor() {
  }

  setup() {
    this.div = document.createElement('div');
    this.div.id = this.id;
    this.div.style.display = "none";

    const label = document.createElement('label');
    label.htmlFor = "pk-info-field-input";
    label.style.display = "block";
    label.style.color = "#c51717";
    label.style.fontWeight = "bold";
    label.style.padding = "1rem 0 1rem 0";
    label.style.lineHeight = "1.4";
    label.style.textAlign = "center";
    label.style.fontSize = "15px";
    label.innerHTML = "Wir versenden Ihre Bestellung aus Verpackungsgründen in folgenden Schritten: 1, 3, 6 oder ein Vielfaches von 6.";

    this.div.appendChild(label)

    this.addElementToDOM()
  }

  elementIsInDom() {
    return document.getElementById(this.id) != null;
  }

  addElementToDOM() {
    let appendToEl = document.querySelector(".drawer__footer")
    console.log("debug-cv", "[setupInfoField]", "appendToEl", appendToEl);
    if (appendToEl) {
      // test store
      appendToEl.appendChild(this.div);
    } else {
      const checkoutBtn = document.querySelector("#checkout-submit")
      if (checkoutBtn && checkoutBtn.parentElement && checkoutBtn.parentElement.parentElement) {
        checkoutBtn.parentElement.parentElement.appendChild(this.div);
      }
    }
  }

  show() {
    if (!this.elementIsInDom()) {
      this.addElementToDOM()
    }
    this.div.style.display = "block";
  }

  hide() {
    this.div.style.display = "none";
  }

}

document.addEventListener('DOMContentLoaded', () => {
  const infoField = new InfoField();
  const cartValidation = new CartValidation(infoField);
  cartValidation.setup();
});
